import { objectiveBasedColumns } from './strategies/objectiveBased'
import { standardColumns } from './strategies/standard'

export const schema = (params: SchemaProps) => {
  const { strategy = 'standard' } = params

  if (strategy === 'objective_based') {
    return objectiveBasedColumns(params)
  }
  return standardColumns(params)
}
